import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionProviderDependencyRow } from "../types";

const ModuleVersionDependenciesTableVersionCell = ({
  item: dependency,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionProviderDependencyRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{dependency.version}</TableCellText>
    </TableSimpleCell>
  );
};

export default ModuleVersionDependenciesTableVersionCell;
